import CheckIcon from "assets/icons/settings/check-icon.svg?react";

interface PlanFeatureListProps {
  features: string[];
}

export default function PlanFeatureList({ features }: PlanFeatureListProps) {
  const midpoint = Math.ceil(features.length / 2);
  const columns = [features.slice(0, midpoint), features.slice(midpoint)];

  return (
    <div className="flex flex-col lg:flex-row gap-2 lg:gap-4">
      {columns.map((column) => (
        <div className="flex flex-col gap-2" key={column[0]}>
          {column.map((feature) => (
            <div className="flex flex-row gap-2" key={feature}>
              <CheckIcon className="size-4" />
              <span className="text-xs-medium">{feature}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
